export const ALLOWED_CNH_CATEGORIES = ["A", "B", "C", "D", "E"] as const;

export type CnhCategory = (typeof ALLOWED_CNH_CATEGORIES)[number];
